import snackbarStore from '../../../../../../stores/Snackbar.store';
import { TranslateType } from '../../../../../translation/translationContext.types';
import { ExceptionPayload } from '../../../chatSocket/hooks/useChatWebsocket/useChatWebsocket.types';
import { WsErrorsStrategy } from '../types/wsErrorsStrategy.type';

export class InvalidPayloadStrategy implements WsErrorsStrategy {
  constructor(private readonly translate: TranslateType) {}

  handle(wsException: ExceptionPayload) {
    snackbarStore.handleMessage({
      type: 'error',
      message: wsException.message,
    });
  }
}
